import { useRef } from 'react';
import Portal from '@reach/portal';
import { AnimatePresence, motion } from 'framer-motion';

import { useLockBodyScroll } from 'lib/hooks/use-lock-body-scroll';
import useClickAway from 'lib/hooks/use-click-away';

import { fadeInOut } from 'lib/framer-motion/fade-in-out';
import { zoomOutIn } from 'lib/framer-motion/zoom-out-in';

import { ModalWrapper } from './modal.style';

import { TYPE_MODAL_VIEW } from 'components/modal-views/context';

type ModalProps = {
  open: boolean;
  view: TYPE_MODAL_VIEW | string;
  onClose: () => void;
};

const Modal = ({
  children,
  open,
  view,
  onClose
}: React.PropsWithChildren<ModalProps>) => {
  const modalInnerRef = useRef<HTMLDivElement>(null);
  let modalClassName = 'modal-full';

  if (view === 'SEND_VIEW') {
    modalClassName = modalClassName + ' modal-top';
  }
  if (view === 'TERM_VIEW') {
    modalClassName = modalClassName + ' modal-term';
  }

  useLockBodyScroll(open);

  useClickAway(modalInnerRef, () => onClose());

  return (
    <Portal>
      <AnimatePresence>
        {open && (
          <ModalWrapper>
            <motion.div
              key="modal"
              initial="from"
              animate="to"
              exit="from"
              variants={fadeInOut(0.25)}
              className="modal-root"
            >
              <motion.div
                initial="from"
                animate="to"
                exit="from"
                variants={zoomOutIn()}
                className="modal-motion"
              >
                <div className={modalClassName}>
                  <div ref={modalInnerRef} className="modal-overflow">
                    {children}
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </ModalWrapper>
        )}
      </AnimatePresence>
    </Portal>
  );
};

export default Modal;
